import { type ReactNode } from 'react';

/**
 * Labelled values, as a description list.
 *
 * `dl`/`dt`/`dd` rather than a div grid, because that is what this is: a
 * screen reader announces "Code, GRD" from the markup alone, where a grid of
 * divs announces two unrelated strings.
 *
 * One implementation, so that a dozen detail screens cannot drift into a dozen
 * label treatments.
 */

export function DetailGrid({ children }: { readonly children: ReactNode }): React.JSX.Element {
  return <dl className="grid gap-field sm:grid-cols-2">{children}</dl>;
}

export interface DetailFieldProps {
  readonly label: string;
  readonly children?: ReactNode;
}

export function DetailField({ label, children }: DetailFieldProps): React.JSX.Element {
  return (
    <div>
      <dt className="text-caption text-muted-foreground">{label}</dt>
      {/* A field with nothing in it says so, rather than rendering an empty
          row the reader has to interpret. Null and empty string are both
          "no value recorded"; only `0` and `false` are real values. */}
      <dd className="text-body">
        {children === null || children === undefined || children === '' ? (
          <span className="text-muted-foreground">Not recorded</span>
        ) : (
          children
        )}
      </dd>
    </div>
  );
}
